import loadable from '@loadable/component';

// View
import AlertBlockView from './Alert/View';
import CorsiBlockView from './CorsiBlock/View';
import HeroImageLeftView from './HeroImageLeft/View';
import TitleBlockView from './Title/View';
import GridColumnBlocksFormView from './GridColumnBlocksForm/View';
import ReviewsBlockView from './Reviews/View';
import ReviewsBlockSchema from './Reviews/schema';
import TableBlockView from './Table/View';
import CardsAppearance from './Listing/Carousel/CardsAppearance';
import CardsWithImageAppearance from './Listing/Carousel/CardsWithImageAppearance';
import CarouselHead from './Listing/Carousel/Head/Head';
import CarouselReadMoreButton from './Listing/Carousel/Head/ReadMoreButton';
import ListingLinkMore from './Listing/Commons/ListingLinkMore';

// less common
const FacultyView = loadable(() =>
  import(/* webpackChunkName: "io-studio" */ './Faculty/View'),
);
const TeachingsView = loadable(() =>
  import(/* webpackChunkName: "io-studio" */ './Teachings/View'),
);
const TeachingsEdit = loadable(() =>
  import(/* webpackChunkName: "io-studio" */ './Teachings/Edit'),
);

// Edit
const AlertBlockEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Alert/Edit'),
);
const CorsiBlockEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './CorsiBlock/Edit'),
);
const FacultyEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Faculty/Edit'),
);
const HeroImageLeftEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './HeroImageLeft/Edit'),
);
const TitleBlockEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Title/Edit'),
);
const GridColumnBlocksFormEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './GridColumnBlocksForm/Edit'),
);
const ReviewsBlockEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Reviews/Edit'),
);
const TableBlockEdit = loadable(() =>
  import(/* webpackChunkName: "vis-manage" */ './Table/Edit'),
);

export {
  AlertBlockEdit,
  AlertBlockView,
  HeroImageLeftView,
  HeroImageLeftEdit,
  TitleBlockView,
  TitleBlockEdit,
  CorsiBlockEdit,
  CorsiBlockView,
  GridColumnBlocksFormView,
  GridColumnBlocksFormEdit,
  ReviewsBlockEdit,
  ReviewsBlockView,
  ReviewsBlockSchema,
  TableBlockEdit,
  TableBlockView,
  TeachingsView,
  TeachingsEdit,
  CardsAppearance,
  CardsWithImageAppearance,
  CarouselHead,
  CarouselReadMoreButton,
  ListingLinkMore,
  FacultyEdit,
  FacultyView,
};
